import { Alert } from "~/common/mui/Alert/Alert";
import { userIsLoggedIn } from "~/domains/user/utils/roles";
import { canSeeCountryOrigin } from "~/utils/siteModes";
import { useTranslation } from "react-i18next";
import ParagraphWithShowAll from "~/common/components/ParagraphWithShowAll/ParagraphWithShowAll";

export interface Props {
  className?: string;
  disabled?: boolean;
  show?: boolean;
}

const DisclaimerCountryOrigin = ({
  className,
  disabled = false,
  show = userIsLoggedIn() && canSeeCountryOrigin(),
}: Props) => {
  const { t } = useTranslation();
  return show && !disabled ? (
    <Alert severity={"info"} className={`scha__disclaimer__country-of-origin ${className ?? ""}`}>
      <div data-test-id={"disclaimer-country-of-origin"}>
        <ParagraphWithShowAll paragraph={t("common.countryOfOrigin.disclaimer")} />
      </div>
    </Alert>
  ) : null;
};

export default DisclaimerCountryOrigin;
